import { Star } from 'lucide-react'

import { useSetFavorite } from '../api/client'
import { de } from '../i18n/de'

/**
 * The star that puts a parcel at the top of *your* board — and, with notifications on,
 * decides what you are told about. Personal: everybody sees their own stars.
 */
export function FavoriteStar({
  parcelId,
  favorite,
  size = 'sm',
}: {
  parcelId: number
  favorite: boolean
  size?: 'sm' | 'md'
}) {
  const setFavorite = useSetFavorite()
  const label = favorite ? de.actions.unfavorite : de.actions.favorite
  const icon = size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5'

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation()
        setFavorite.mutate({ id: parcelId, favorite: !favorite })
      }}
      disabled={setFavorite.isPending}
      title={label}
      aria-label={label}
      aria-pressed={favorite}
      className={`-m-1.5 rounded p-2.5 transition ${
        favorite
          ? 'text-amber-500 hover:text-amber-600 dark:text-amber-400'
          : 'text-slate-300 hover:text-amber-500 dark:text-slate-600 dark:hover:text-amber-400'
      }`}
    >
      <Star className={icon} fill={favorite ? 'currentColor' : 'none'} aria-hidden />
    </button>
  )
}
